const resources = {
    sponsored: 'Sponsored',
    alt: 'Image de bannière avec contenu sponsorisé',
    moreToChooseFrom: 'More To Choose From'
};

module.exports = function getResource(label) {
    return resources[label];
};
